export const boardScreenCheckTour = {
  key: "boardScreenCheck",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-screencheck-status"]',
      content: t("Tour_BoardScreenCheck_Status"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-screencheck-start"]',
      content: t("Tour_BoardScreenCheck_Start"),
      placement: "left",
    },
    {
      target: '[data-tour="board-screencheck-report"]',
      content: t("Tour_BoardScreenCheck_Report"),
      placement: "top",
    },
    {
      target: '[data-tour="board-screencheck-screenshots"]',
      content: t("Tour_BoardScreenCheck_Screenshots"),
      placement: "top",
    },
  ],
};
